<script setup>
import VueApexCharts from 'vue3-apexcharts';

const props = defineProps({
  // 월별 에너지 데이터 [1월 ~ 12월]
  data: {
    type: Array,
    default: () => Array(12).fill(0),
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
});

const categories = [
  '1월',
  '2월',
  '3월',
  '4월',
  '5월',
  '6월',
  '7월',
  '8월',
  '9월',
  '10월',
  '11월',
  '12월',
];

const series = computed(() => [
  {
    name: '에너지',
    data: props.data,
  },
]);

const chartOptions = computed(() => ({
  chart: {
    type: 'line',
    toolbar: { show: false },
    zoom: { enabled: false },
    parentHeightOffset: 0,
    animations: {
      enabled: false,
    },
  },
  colors: ['#f80'],
  stroke: {
    width: 3,
    curve: 'straight',
  },
  markers: {
    size: 4,
    colors: ['#fff'],
    strokeColors: '#f80',
    strokeWidth: 2,
  },
  xaxis: {
    categories,
    axisTicks: { show: false },
    axisBorder: { show: false },
    tickPlacement: 'between',
    labels: {
      style: {
        fontFamily: 'Pretendard',
        fontSize: '12px',
        fontWeight: '700',
        colors: '#333',
      },
    },
  },
  yaxis: {
    min: 0,
    max: 100,
    tickAmount: 4,
    labels: {
      show: false,
    },
  },
  grid: {
    borderColor: '#EBEBEB',
    strokeDashArray: 0,
    padding: {
      top: 0,
      bottom: 0,
    },
  },
  dataLabels: {
    enabled: false,
  },
  tooltip: {
    enabled: true,
    y: {
      formatter: (val) => `${val}%`,
    },
  },
}));
</script>

<template>
  <div class="monthly-energy-chart">
    <VueApexCharts
      type="line"
      :height="props.isMobile ? 197 : 247"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<style scoped lang="scss">
.monthly-energy-chart {
  width: 100%;

  // 라인이 왼쪽에서 오른쪽으로 그려지는 애니메이션
  :deep(.apexcharts-line-series path) {
    stroke-dasharray: 2000;
    stroke-dashoffset: 2000;
    animation: draw-line 2.5s linear forwards;
  }

  // 마커 - 라인 완료 후 일괄 페이드인
  :deep(.apexcharts-series-markers) {
    opacity: 0;
    animation: fade-in 0.5s ease forwards 0.3s;
  }

  @media (max-width: 768px) {
    width: calc(100% + 16px);
    margin-left: -16px;
  }
}

@keyframes draw-line {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes fade-in {
  to {
    opacity: 1;
  }
}
</style>
